import type { SVGProps } from "react";
export interface CalendarStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CalendarStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CalendarStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 6.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M19.875 6c0-.996-.778-1.81-1.76-1.87a1.124 1.124 0 0 1-2.233-.005H8.118a1.125 1.125 0 0 1-2.235.005A1.874 1.874 0 0 0 4.125 6v12c0 1.036.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm-8.997 3.954a1.377 1.377 0 0 1 2.244 0l.105.176.838 1.668 1.881.27c1.104.157 1.603 1.531.758 2.34l-1.351 1.293.318 1.82.022.214c.027.97-.953 1.614-1.82 1.314l-.185-.077L12 18.099l-1.688.873c-.967.5-2.185-.291-1.983-1.45l.317-1.821-1.35-1.292c-.845-.81-.346-2.184.758-2.341l1.88-.27.839-1.668zm.804 3.381c-.165.33-.482.556-.847.608l-.672.095.473.453c.271.259.394.637.33 1.006l-.117.664.635-.327.123-.056c.295-.11.625-.09.909.056l.634.327-.116-.664c-.064-.37.059-.747.33-1.006l.471-.453-.67-.095a1.13 1.13 0 0 1-.847-.608L12 12.701zM22.125 18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6a4.12 4.12 0 0 1 4.006-4.119 1.125 1.125 0 0 1 2.237-.006h7.764a1.125 1.125 0 0 1 2.235.006 4.12 4.12 0 0 1 4.008 4.12v12Z"
      />
    </svg>
  );
}
